import { Tab } from "@mui/material";
import { ReactComponent as AlertTriangleIcon } from "components/Icons/alert-triangle.svg";
import { ReactComponent as XCloseIcon } from "components/Icons/x-close.svg";
import { useStyles as useTabsStyles } from "components/Tabs/OLTabs.styles";
import { OLModal } from "components/Tooltips/OLModal";
import { Tooltip } from "components/Tooltips/Tooltip";
import { useMessage } from "hooks/intl";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useStyles } from "../../TiersForm.styles";

interface Props {
  index: number;
  tierName: string;
  areTierErrors: boolean;
  isSelected: boolean;
  setActiveTier: Dispatch<SetStateAction<number>>;
  activeTier: number;
  remove: (index: number) => void;
  isDefault?: boolean;
}

export const TierTab = ({
  index,
  tierName,
  areTierErrors,
  isSelected,
  setActiveTier,
  activeTier,
  remove,
  isDefault,
  ...rest
}: Props) => {
  const [displayTabError, setDisplayTabError] = useState(areTierErrors);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const classes = useStyles();
  const tabClasses = useTabsStyles();
  const { message } = useMessage();
  const maxNameLength = 12;
  const isNameTooLong = tierName && tierName.length > maxNameLength;

  useEffect(() => {
    setDisplayTabError(areTierErrors);
  }, [areTierErrors]);

  useEffect(() => {
    if (!isSelected && displayTabError) setDisplayTabError(false);
    // eslint-disable-next-line
  }, [isSelected]);

  return (
    <Tab
      {...rest}
      value={index}
      className={tabClasses.tab}
      label={
        <div
          data-id="tab"
          onClick={(e) => {
            const { target } = e;

            if ((target as HTMLElement).dataset.id === "tab") {
              setActiveTier(index);
            }
          }}
          className={classes.itemWrapper}
        >
          {!isSelected && displayTabError && (
            <AlertTriangleIcon
              onClick={() => setActiveTier(index)}
              className={`${!isSelected && classes.warnIcon}`}
            />
          )}
          <Tooltip text={isNameTooLong ? tierName : ""}>
            <span onClick={() => setActiveTier(index)}>
              {isNameTooLong
                ? `${tierName.substring(0, maxNameLength)}...`
                : tierName}
            </span>
          </Tooltip>

          {!isDefault && (
            <XCloseIcon
              className={classes.closeIcon}
              onClick={() => {
                setIsDeleteModalOpen(true);
              }}
            />
          )}

          <OLModal
            open={isDeleteModalOpen}
            onClose={() => setIsDeleteModalOpen(false)}
            header={message({ id: "areYouSureYouWantToDeleteThat" })}
            submitAction={() => {
              if (index <= activeTier) {
                setActiveTier(activeTier > 0 ? activeTier - 1 : 0);
              }

              remove(index);
              setIsDeleteModalOpen(false);
            }}
            cancelText={message({ id: "cancel" })}
            submitText={`${message({ id: "yes" })}, ${message({
              id: "delete",
            })}`}
          >
            <p className={classes.modalDescription}>
              {message({ id: "changesWillBeLost" })}
            </p>
          </OLModal>
        </div>
      }
    />
  );
};
